<template>
  <div>
    <div style="height: 70vh">
      <DokaImageEditor style="height:70vh" v-bind="editorProps" :src="inlineSrc" @doka:load="handleInlineLoad($event)" @doka:process="handleInlineProcess($event)" />
    </div>
    <div class="docka-action-btn">
      <div class="options d-flex align-items-center justify-content-center">
        <button class="btn btn-hollow" @click="retakeDokaImage">
          <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5 5V1L7.5 6L12.5 11V7C15.81 7 18.5 9.69 18.5 13C18.5 16.31 15.81 19 12.5 19C9.19 19 6.5 16.31 6.5 13H4.5C4.5 17.42 8.08 21 12.5 21C16.92 21 20.5 17.42 20.5 13C20.5 8.58 16.92 5 12.5 5Z" fill="#FFE607" />
          </svg>
          Retake
        </button>
        <button class="btn btn-submit" @click="submitDockerImage">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.58997 16.34L13.17 11.75L8.58997 7.16L9.99997 5.75L16 11.75L9.99997 17.75L8.58997 16.34Z" fill="#050505" />
          </svg>
          Submit
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
// Import vue-doka
import { DokaImageEditor } from "vue-doka";

// Import doka
import {
  // editor
  createDefaultImageReader,
  createDefaultImageWriter,
  locale_en_gb,

  // plugins
  setPlugins,
  plugin_crop,
  plugin_crop_defaults,
  plugin_crop_locale_en_gb,
  // plugin_filter,
  plugin_filter_defaults,
  plugin_filter_locale_en_gb,
  plugin_finetune,
  plugin_finetune_defaults,
  plugin_finetune_locale_en_gb,
  plugin_annotate,
  plugin_sticker,
  plugin_annotate_locale_en_gb,
  markup_editor_defaults,
  markup_editor_locale_en_gb,
  plugin_sticker_locale_en_gb,

  // filepond
  // openEditor,
  // processImage,
  // createDefaultImageOrienter,
  // legacyDataToImageState,
} from "doka";

setPlugins(plugin_crop, plugin_annotate, plugin_sticker, plugin_finetune);

// Create FilePond component
// const FilePond = vueFilePond(
//     FilePondPluginFileValidateType,
//     FilePondPluginImageEditor,
//     FilePondPluginFilePoster
// );

export default {
  name: "App",
  props: ["image"],
  components: {
    DokaImageEditor,
  },
  created() {
    parent.postMessage({dockerScreen: true} , '*')
    document.getElementsByClassName("full-width")[0].style.maxWidth = "100%";
    this.inlineSrc = this.image;
  },
  methods: {
    // inline
    handleInlineLoad: function(res) {
      console.log("inline load", res);
    },
    handleInlineProcess: function(res) {
      console.log("inline process", res);
       this.$emit("dockaImageSubmit" , res)
      this.inlineResult = URL.createObjectURL(res.dest);
    },

    // overlay
    handleOverlayLoad: function(res) {
      console.log("overlay load", res);
    },
    handleOverlayProcess: function(res) {
      console.log("overlay process", res);
      const { imageState, dest } = res;
      this.overlayResult = {
        imagePreview: URL.createObjectURL(dest),
        imageState: imageState,
      };
      this.overlayVisible = false;
    },

    // filepond
    handleFilePondInit: function() {
      console.log("FilePond has initialized");
      // FilePond instance methods are available on `this.$refs.pond`
    },
    submitDockerImage() {
      $('.DokaButtonExport').trigger('click')
      // console.log("SUBMIT CLICK")
    },
    retakeDokaImage() {
    // console.log("retakeDokaImage")
     this.$emit("retakeDokaImage")
    }
  },
  data() {
    return {
      // defaults
      editorProps: {
        imageReader: createDefaultImageReader(),
        imageWriter: createDefaultImageWriter(),
        ...plugin_crop_defaults,
        ...plugin_finetune_defaults,
        ...plugin_filter_defaults,
        ...markup_editor_defaults,
        locale: {
          ...locale_en_gb,
          ...plugin_crop_locale_en_gb,
          ...plugin_finetune_locale_en_gb,
          ...plugin_filter_locale_en_gb,
          ...plugin_annotate_locale_en_gb,
          ...markup_editor_locale_en_gb,
          ...plugin_sticker_locale_en_gb,
        },
        stickers: [
          ["Emoji", ["⭐️", "😊", "👍", "👎", "☀️", "🌤", "🌥"]],
          // [
          //   "Markers",
          //   [
          //     {
          //       src: "sticker-one.svg",
          //       width: "5%",
          //       height: "5%",
          //       alt: "One",
          //     },
          //     {
          //       src: "sticker-two.svg",
          //       width: "5%",
          //       height: "5%",
          //       alt: "Two",
          //     },
          //     {
          //       src: "sticker-three.svg",
          //       width: "5%",
          //       height: "5%",
          //       alt: "Three",
          //     },
          //   ],
          // ],
        ],
      },
      // inline state
      inlineSrc: "image.jpeg",
      inlineResult: undefined,

      // modal state
      modalSrc: "image.jpeg",
      modalVisible: false,
      modalResult: undefined,

      // overlay state
      overlaySrc: "image.jpeg",
      overlayVisible: false,
      overlayResult: {
        imageState: undefined,
        imagePreview: undefined,
      },
      myFiles: [],
    };
  },
  beforeDestroy() {
    document.getElementsByClassName("full-width")[0].style.maxWidth = "420px";
    parent.postMessage({dockerScreen: false} , '*')
  }
};
</script>

<style>
@import "../../node_modules/doka/doka.css";
.doka-image-editor {
  --color-background: 0, 0, 0;
  --color-foreground: 255, 255, 255;
  box-shadow: none !important;
}
img {
  max-width: 100%;
}
.doka-image-editor {
  --font-family: "Poppins", sans-serif;
}
.DokaButtonExport {
  display: none;
}
.docka-action-btn {
  background: #000;
  padding: 12px;
  padding-bottom: 40px;
}

.doka-image-editor {
  box-shadow: 0 0 0 1px #eee;
}
</style>
<style scoped>
.btn-hollow {
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  letter-spacing: 0.01em;
  color: #ffe607;
  border-color: #ffe607;
  height: 50px;
    padding: 0px 41px;
}
.btn-hollow:hover {
  color: #ffe607;
}
.btn-submit {
  margin-left: 8px;
  font-size: 12px;
  line-height: 18px;
  background: #ffe607;
  /* identical to box height, or 150% */
  text-align: center;
  letter-spacing: 0.01em;
  color: #050505;
  height: 50px;
    padding: 0px 41px;
}
</style>
